exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-link[data-v-2f4a0ba9]{font-family:Pragmatica;font-size:14px;line-height:1.57}.footer-link[data-v-2f4a0ba9]:hover{opacity:.6}.footer-link--cannes span[data-v-2f4a0ba9]{color:#f45152}.footer-link--kinotavr span[data-v-2f4a0ba9]{color:#d7bc5b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f4a0ba9","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/includes/mfooter.vue
// module id = 508
// module chunks = 0